/**
 * Created by Languagenut on 19/06/2019.
 */

import React  from 'react';
import {Form , Alert , Spinner , Col , Row  , Modal , Button} from 'react-bootstrap'
import FieldGroup from '../FieldGroup.js';
import Translation from '../../store/internationalization-store.js'
import validator from 'validator';
import {UserService} from '../../services';
import Downloader from '../../classes/download.js';


export default class TextPopup extends React.Component {

    constructor(props) {
        super();
        this.props = props;

        this.state = {
            name: '',
            user_type:'teacher',
            thinking:false,
            made:false,
            duplicateEmail:false,
            saveButtonPressed:false
        };
    }

    componentWillReceiveProps(props){
        this.props = props;
        this.state = {
            name: '',
            user_type:'teacher',
            thinking:false,
            made:false,
            password:'',
            duplicateEmail:false,
            saveButtonPressed:false
        };

        if(this.props.show)
        {
            console.log('hello my name is ')
            setTimeout(function(){
                var focuse = document.getElementById('student-title');
                console.log(focuse)
                if(focuse) focuse.focus()
            }, 500)

        }
    }

    validate(id){

        switch(id)
        {
            case "title": return !validator.isEmpty(String(this.state.title));
            case "first_name": return !validator.isEmpty(String(this.state.first_name));
            case "last_name": return !validator.isEmpty(String(this.state.last_name));
            case "email":
                if (this.state.duplicateEmail) {
                    return false;
                } else if (this.state.email == undefined || this.state.email == "") {
                    return false;
                } else {
                    return validator.isEmail(String(this.state.email))
                }

                break;
            case "phone_number": return !validator.isEmpty(String(this.state.phone));
        }

        return true;
    }

    componentDidMount(){

    }

    getDisplayOption(optionID){

        switch(optionID)
        {
            default: return (this.state.title || '')+' '+(this.state.last_name || '')
            case "2": return (this.state.title || '')+' '+String((this.state.first_name || '')).charAt(0).toUpperCase()+'. '+(this.state.last_name || '')
            case "3": return String((this.state.first_name || ''));
            case "4": return String((this.state.first_name || ''))+' '+(this.state.last_name || '')
        }
    }


    displayOptions(){
        return [
            <option value="1">{this.getDisplayOption()}</option>,
            <option value="2">{this.getDisplayOption("2")}</option>,
            <option value="3">{this.getDisplayOption("3")}</option>,
            <option value="4">{this.getDisplayOption("4")}</option>,
        ]
    }

    nameToOption(name){
        if(!isNaN(name)) return name;
        if(this.state.title+' '+this.state.last_name == name)
        {
            return "2";
        }

        if(String(this.state.first_name) == name)
        {
            return "3";
        }

        if(String(this.state.first_name)+' '+this.state.last_name == name)
        {
            return "4";
        }

        return "1";
    }

    save(){
        
        UserService.emailExsit(this.state.email).then(function(exisit){

            if(exisit && this.state.email != this.state.baseEmail){

                this.setState({
                    duplicateEmail:true,
                    saved:false,
                });

                return;
            }

            if(this.validate('title') && this.validate('first_name') && this.validate('last_name') && this.validate('email'))
            {
                this.setState({thinking:true})
                if ( this.state.saveButtonPressed == true) {
                    return;
                }
                this.state.saveButtonPressed = true;
                UserService.make(this.state.title , this.getDisplayOption(this.state.nickname) , this.state.first_name , this.state.last_name , this.state.email , this.state.user_type).then(function(response){


                    this.setState({
                        thinking:false,
                        made:true,
                        password:response.password

                    });



                }.bind(this))

            }

        }.bind(this));
    }

    download(){

        let csv = Translation.get(14 , 'Name')+','+Translation.get(22 , 'Username')+','+Translation.get(23 , 'Password') + '\n';
        csv += (this.state.first_name+' '+this.state.last_name+','+this.state.email+','+this.state.password);

        (new Downloader()).download_csv(csv , this.state.email+'-logins')
    }

    render() {

        let Buttons = <Modal.Footer>{[<Button onClick={this.save.bind(this)}>{Translation.get(657 , 'Save')}</Button>]}</Modal.Footer>

        let error = null;


        let body = <Row className="strong">
            <Col md={12}>
                <Row>
                    <Col md={12}>
                        <Row>
                            <Col md={2}>
                                <FieldGroup autofocus={true} state={!this.validate('title') ? "invalid" : ""}  onChange={(event)=>{this.setState({saved:false, title:event.target.value})}} value={this.state.title} id="student-title" label={Translation.get(2202 , 'Title')}/>
                            </Col>
                            <Col md={5}>
                                <FieldGroup state={!this.validate('first_name') ? "invalid" : ""} help={!this.validate('first_name') ? Translation.get(12782, "This can't be blank") : ""} onChange={(event)=>{this.setState({saved:false, first_name:event.target.value})}} value={this.state.first_name} id="student-name" label={Translation.get(579, 'First Name')}/>
                            </Col>
                            <Col md={5}>
                                <FieldGroup state={!this.validate('last_name') ? "invalid" : ""} help={!this.validate('last_name') ? Translation.get(12782, "This can't be blank") : ""} onChange={(event)=>{this.setState({saved:false, last_name:event.target.value})}} value={this.state.last_name} id="student-name" label={Translation.get(580 , 'Last Name')}/>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <div className="d-flex flex-column">
                                    <Form.Group  controlId="formGridState">
                                        <Form.Label>{Translation.get(12656, 'Display Name')}</Form.Label>
                                        <Form.Control as="select" onChange={(event)=>{this.setState({saved:false, nickname:event.target.value})}}  value={this.nameToOption(this.state.nickname)}>
                                            {this.displayOptions()}
                                        </Form.Control>

                                    </Form.Group>
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="d-flex flex-column">
                                    <Form.Group  controlId="formGridState">
                                        <Form.Label>{Translation.get(12662, 'Access Level')}</Form.Label>
                                        <Form.Control as="select" onChange={(event)=>{this.setState({saved:false, user_type:event.target.value})}}  >
                                            <option value="teacher">{Translation.get(4 , 'Teacher')}</option>,
                                            <option value="school">{Translation.get(12663 , 'Admin')}</option>,
                                        </Form.Control>

                                    </Form.Group>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <FieldGroup state={!this.validate('email') ? "invalid" : ""} help={!this.validate('email') ? this.state.duplicateEmail == true ? "Email has been taken" : Translation.get(1033, "Invalid email") : ""} onChange={(event)=>{this.setState({saved:false, duplicateEmail:false , email:event.target.value})}} value={this.state.email} id="student-name" label={Translation.get(9 , 'Email')}/>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <Alert key={'warning'} variant={'danger'}>
                                    {Translation.get(12664 , 'A secure password will be generated by our system')}
                                </Alert>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
            <br/>
            <Col md={12}>
                {error}
            </Col>
        </Row>


        if(this.state.thinking)
        {
            body = null;
            Buttons = <Modal.Footer><Spinner animation="border" size="sm" /></Modal.Footer>
        }


        if(this.state.made)
        {
             body = [<center><h5>{Translation.get(12652 , 'Teachers\' Login Details')}</h5></center>,<br/>,<center><h4>{String(Translation.get(22 , 'Username:') +' '+this.state.email)}</h4></center>,<center><h4>{String(Translation.get(23 , 'Password:') +' '+this.state.password)}</h4></center>,<br/>,<center><h5>{Translation.get(12770 , 'Please keep your details safe and secure')}</h5></center>]
             Buttons = <Modal.Footer>{[<Button onClick={this.download.bind(this)}>{Translation.get(826 , 'Download')}</Button>,<Button onClick={this.props.onHide}>{Translation.get(225 , 'Exit')}</Button>]}</Modal.Footer>
        }


        return (
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                >
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    {body}
                </Modal.Body>
                {Buttons}
            </Modal>
        );
    }
}